(function () {
    'use strict';
    var controllerId = 'cndPartecipInfoEditAmmiss';
    angular.module('app').controller(controllerId, ['common', '$scope', '$uibModalInstance', '_', 'datacontext', 'sectionMenu', 'partecipazione', 'isSuper', cndPartecipInfoEditAmmiss]);

    function cndPartecipInfoEditAmmiss(common, $scope, $uibModalInstance, _, datacontext, sectionMenu, partecipazione, isSuper) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.partecipazione = jQuery.extend({}, partecipazione);
        $scope.isSuper = isSuper;

        $scope.ok = function (isValid) {
            if (isValid) {
                var result;
                result = updateItem($scope.partecipazione);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


        function updateItem(item) {
            return datacontext.partecipazione_update(item).then(function (data) {

                return data;
            });
        }

    }
})();